/**
 * The three things a screen says when it is not showing what it is for: loading, failed, empty.
 *
 * Separate components rather than one with a mode, because they are three different claims. An
 * empty state is a statement about the person's workspace; a failure is a statement about the
 * request; a loading state is a statement about neither, and must never be mistaken for the first.
 */

import type { ReactNode } from "react";

import type { ApiError } from "../lib/api/errors";

export function Loading({ what }: { what: string }) {
  return (
    <p className="loading" role="status">
      Loading {what}…
    </p>
  );
}

export function ErrorNotice({ error, onRetry }: { error: ApiError; onRetry?: () => void }) {
  return (
    <div className="error-notice" role="alert">
      <p className="error-notice__message">{error.message}</p>
      {onRetry !== undefined && (
        <button className="button-secondary" type="button" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}

export function EmptyState({
  eyebrow,
  headline,
  children,
  actions,
}: {
  eyebrow?: string;
  headline: string;
  children?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <section className="empty">
      {eyebrow !== undefined && <p className="empty__eyebrow">{eyebrow}</p>}
      <p className="empty__headline">{headline}</p>
      {children}
      {actions !== undefined && <div className="empty__actions">{actions}</div>}
    </section>
  );
}
